/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { environment } from "src/environments/environment";
import { BettingAPI, CateringAPI, PromotionsAPI } from "../constants/apiURL";

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

    private cache = new Map<string, HttpResponse<any>>();

    private endpointsToCache = new Set([
        CateringAPI.GET_ALL_SPECIAL_OFFERS,
        BettingAPI.GET_ALL_SPECIAL_OFFERS,
        PromotionsAPI.GET_ALL_PROMOTIONS,
    ]);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = request.url.replace(environment.baseUrl, "");

        if (this.endpointsToCache.has(url)) {

            const cachedResponse = this.cache.get(request.url);

            if (cachedResponse) {
                return of(cachedResponse);
            }

            return next.handle(request).pipe(
                tap((response) => {
                    if (response instanceof HttpResponse) {
                        this.cache.set(request.url, response);
                    }
                })
            );
        }

        return next.handle(request);
    }
}